export default __webpack_public_path__ + "static/media/skyniche_logo.44dda49d.png";